{
  "notes": "Notes",
  "notes-empty": "Add notes.",
  "immediate-family": "Immediate Family",
  "immediate-family-empty": "Add immediate family",
  "family-age": ", Age {{age}}",
  "family-age-months": ", Age {{age}} Months",
  "net-worth-progress": "Net Worth Progress",
  "annual-spending": "Annual Spending*",
  "personal-financial-statement": "Personal Financial Statement",
  "total-assets": "Total Assets",
  "total-debts": "Total Debts",
  "remove-app-access": "Remove App Access",
  "invitation-sent": "Invitation sent {{when}}",
  "mark-onboarding-as-completed": "Mark Onboarding as Completed",
  "onboarding-banner-body": "We’ll hold off on calculating progress in reports until you let us know {{- name}} {{isAre}} fully onboarded.",
  "remove-access-modal-ok": "Remove Access",
  "remove-access-modal-title": "Remove Client Access to Elements?",
  "remove-access-modal-body": "By removing client access to Elements they will no longer be able to access the Elements app.",
  "resend-invitation-body": "Verify the email addresses below and resend the invitation to {{- who}} to join you on Elements.",
  "important-people": "Important People",
  "other-relationship": "Other Relationships",
  "create-one-page-plan": "Create One-Page Plan",
  "one-page-plan-banner-text": "Don't forget—creating a One Page Plan for your client is a great way to help them stay focused and make progress.",
  "edit-financial-purpose-meta-title": "Edit the client's financial purpose",
  "edit-financial-purpose-heading": "Edit Financial Purpose",
  "edit-financial-purpose-placeholder": "Add your client’s financial purpose here...",
  "edit-goals-heading": "Edit Goals",
  "edit-goals-meta-title": "Create, edit, and delete financial goals for this client",
  "client-goals-empty": "Add client goals.",
  "client-next-steps-empty": "Add tasks.",
  "edit-next-steps-meta-title": "Create, edit, and delete tasks for this client",
  "edit-next-steps-heading": "Edit Tasks",
  "add-individual": "Add Individual",
  "edit-individual": "Edit Individual",
  "remove-individual-modal-title": "Remove Individual?",
  "remove-individual-modal-body": "Removing this person will delete them from your client’s profile and they will lose their access to the Elements app. Additionally, any assets or debts assigned to them will revert their ownership back to the primary head-of-household. This action cannot be undone.",
  "remove-individual-modal-ok": "Remove Individual",
  "prospect-banner-body_one": "{{- name}} is a prospect. Convert this prospect to a client to move them to your “Onboarding Group”",
  "prospect-banner-body_other": "{{- name}} are prospects. Convert them to a client to move them to your “Onboarding Group”.",
  "include-debt-payments": "*include debt payments",
  "remove-client": "Remove Client",
  "remove-client-modal-title": "Remove Client?",
  "remove-client-modal-body": "Removing a client will delete them from your list of clients and cannot be undone.",
  "remove-client-notification": "You have removed {{- user}} from your client list.",
  "decayed-percentage": "{{- percentage}}% of balances are decayed",

  "client-page-household-income-button-label": "Household Income",
  "client-page-annual-spending-button-label": "Annual Spending",
  "client-page-scorecard-button-no-report": "Report unavailable",
  "client-page-scorecard-full-screen-button": "Full Screen",
  "client-details-tab-overview": "Overview",
  "client-details-tab-projection": "Projection",
  "client-details-tab-accounts": "Accounts",
  "client-details-tab-tasks-goals": "Tasks & Goals",
  "client-details-tab-documents-estate": "Documents",
  "client-details-download-progress-report": "Download Progress Report",
  "client-details-download-pfs-report": "Download Personal Financial Statement",
  "client-details-open-one-page-plan": "Open One-Page Plan",
  "client-projection-loading": "Loading projection",
  "client-projection-unavailable-heading": "Projection is unavailable",
  "client-projection-unavailable-body": "We could not build this planning estimate. Check the household inputs and try again.",
  "client-projection-retry": "Retry projection",
  "client-projection-tooltip-heading": "Age {{age}} · {{year}}",
  "client-projection-retirement-handle-help": "Drag horizontally or use the arrow keys to change retirement age.",
  "client-projection-retirement-age-live": "Retirement age {{age}}",
  "client-projection-age": "Age",
  "client-projection-retirement-age": "Retirement age",
  "client-projection-retirement-spending": "Retirement spending",
  "client-projection-inputs-loading": "Loading projection inputs",
  "client-projection-inputs-unavailable": "Projection inputs are unavailable",
  "client-projection-inputs-retry": "Retry projection inputs",
  "client-projection-inputs-source-accounts": "Accounts",
  "client-projection-inputs-source-persons": "Household members",
  "client-projection-inputs-source-spending": "Household spending",
  "client-projection-inputs-source-income": "Income",
  "client-projection-inputs-source-error-accounts": "We couldn't load account data.",
  "client-projection-inputs-source-error-persons": "We couldn't load household members.",
  "client-projection-inputs-source-error-spending": "We couldn't load household spending.",
  "client-projection-inputs-source-error-income": "We couldn't load income data.",
  "client-projection-inputs-review-heading": "Review projection inputs",
  "client-projection-inputs-loaded-at": "Loaded {{date}}",
  "client-projection-inputs-planning-person": "Planning person",
  "client-projection-inputs-suggested": "Suggested",
  "client-projection-inputs-excluded-by-default": "Excluded by default",
  "client-projection-inputs-accounts": "Projection accounts",
  "client-projection-inputs-account-balance": "Balance",
  "client-projection-inputs-annual-contribution": "Annual contribution",
  "client-projection-inputs-household-spending": "Household spending",
  "client-projection-inputs-income-count": "Income sources ({{count}})",
  "client-projection-inputs-income-excluded": "Excluded pending income review",
  "client-projection-inputs-income-empty": "No income sources were found.",
  "client-projection-inputs-income-starts": "Starts {{date}}",
  "client-projection-inputs-missing": "Missing",
  "client-projection-inputs-issue-unsupported-currency": "Unsupported currency",
  "client-projection-inputs-issue-missing-source-value": "Missing source value",
  "client-projection-inputs-issue-invalid-money": "Invalid money value",
  "client-projection-inputs-issue-incomplete-source": "Source list is incomplete",
  "client-projection-inputs-issue-source-failed": "Source could not be loaded",
  "client-projection-inputs-issue-unsupported-frequency": "Unsupported payment frequency",
  "client-projection-inputs-issue-required-money-missing": "Required amount is missing",
  "client-projection-inputs-issue-planning-person-missing": "Choose a planning person",
  "client-projection-inputs-issue-source-changed": "Source data changed",
  "client-projection-inputs-issue-annuity-double-count": "An annuity is included as both an account and income. Include it only once.",
  "client-projection-inputs-issue-review": "Projection input needs review",
  "client-projection-inputs-issue-field-account-contribution": "{{name}} annual contribution",
  "client-projection-inputs-issue-field-account-balance": "{{name}} balance",
  "client-projection-inputs-issue-field-account": "{{name}}",
  "client-projection-inputs-issue-field-income-name": "{{name}}",
  "client-projection-inputs-issue-field-spending": "Household spending",
  "client-projection-inputs-issue-field-planning-person": "Planning person",
  "client-projection-inputs-issue-field-accounts": "Accounts",
  "client-projection-inputs-issue-field-income": "Income",
  "client-projection-inputs-overrides": "Advisor overrides (optional)",
  "client-projection-inputs-temporary": "Temporary · resets on page reload.",
  "client-projection-inputs-starting-assets-override": "Starting retirement assets override",
  "client-projection-inputs-annual-savings-override": "Annual savings override",
  "client-projection-inputs-retirement-spending-override": "Annual retirement spending override",
  "client-projection-inputs-override-invalid": "Enter a nonnegative amount or leave this field blank.",
  "client-projection-inputs-blockers": "Resolve before confirming",
  "client-projection-inputs-blocker-guidance": "Correct the source data, then retry before confirming.",
  "client-projection-inputs-retry-sources": "Retry source data",
  "client-projection-inputs-warnings": "Review notes",
  "client-projection-inputs-confirm": "Confirm inputs",
  "client-projection-inputs-confirming": "Confirming inputs",
  "client-projection-v1-basis": "Base assumption · Today’s dollars",
  "client-projection-v1-heading": "Retirement projection",
  "client-projection-v1-base-funded-through": "{{name}}’s projected assets cover modeled cash flows through age {{age}} under the base assumptions.",
  "client-projection-v1-base-shortfall": "{{name}}’s first modeled unfunded year occurs at age {{age}} under the base assumptions.",
  "client-projection-v1-session-note": "Deterministic planning estimate · Temporary · resets on page reload.",
  "client-projection-v1-income-not-included": "Available income sources are not included until an advisor reviews their timing and treatment.",
  "client-projection-v1-chart-label": "{{name}}’s projected retirement assets by age under lower, base, and higher return assumptions",
  "client-projection-v1-updated-inputs-available": "New household data is available. Your confirmed projection has not changed.",
  "client-projection-v1-review-updated-inputs": "Review updated inputs",
  "client-projection-v1-refresh-failed": "Couldn't refresh source data. Showing the confirmed inputs.",
  "client-projection-v1-retry-refresh": "Retry refresh",
  "client-projection-v1-discard-for-refresh-confirmation": "Reviewing updated inputs will discard temporary projection changes. Continue?",
  "client-projection-v1-core-controls-heading": "Explore the plan",
  "client-projection-v1-core-controls-context": "Adjust {{name}}’s core retirement levers.",
  "client-projection-v1-core-controls-live-note": "The projection updates as you edit.",
  "client-projection-v1-monthly-savings": "Monthly savings",
  "client-projection-v1-monthly-retirement-spending": "Monthly retirement spending",
  "client-projection-v1-years-unit": "years",
  "client-projection-v1-per-month-unit": "/mo",
  "client-projection-v1-age-value": "Age {{age}}",
  "client-projection-v1-monthly-value": "{{value}} per month",
  "client-projection-v1-control-required": "Enter a value.",
  "client-projection-v1-retirement-age-error": "Enter a whole age from {{minimum}} to {{maximum}}.",
  "client-projection-v1-monthly-money-error": "Enter an amount of $0 or more.",
  "client-projection-v1-last-valid-result": "Showing the last valid projection—current edits are invalid.",
  "client-projection-v1-axis-context": "Age · {{name}}",
  "client-projection-v1-result-updated": "{{name}}’s projection updated.",
  "client-projection-v1-pending-changes": "Pending projection changes",
  "client-projection-v1-retirement-age-delta": "Retirement age {{delta}} years",
  "client-projection-v1-monthly-savings-delta": "Monthly savings {{delta}}",
  "client-projection-v1-monthly-spending-delta": "Retirement spending {{delta}}",
  "client-projection-v1-assumptions-delta": "Projection assumptions changed",
  "client-projection-v1-income-delta": "Guaranteed income changed",
  "client-projection-v1-milestones-delta": "Milestones changed",
  "client-projection-v1-fix-edits-before-applying": "Fix the current edits before applying.",
  "client-projection-v1-apply-temporary-note": "Apply keeps these changes only until the page reloads.",
  "client-projection-v1-discard": "Discard",
  "client-projection-v1-apply": "Apply until reload",
  "client-projection-v1-applying": "Applying…",
  "client-projection-v1-apply-confirmed": "Temporary changes applied. They will reset on page reload.",
  "client-projection-v1-apply-failed": "We couldn't apply these temporary changes. Try again.",
  "client-projection-v1-navigation-guard-title": "Leave Projection?",
  "client-projection-v1-navigation-guard-body": "Your temporary projection changes will be lost.",
  "client-projection-v1-navigation-guard-stay-action": "Stay",
  "client-projection-v1-navigation-guard-leave-action": "Leave",
  "client-projection-v1-assumptions-heading": "Projection assumptions",
  "client-projection-v1-assumptions-show": "Edit assumptions",
  "client-projection-v1-assumptions-hide": "Hide assumption controls",
  "client-projection-v1-assumptions-defaults": "Illustrative defaults",
  "client-projection-v1-assumptions-edited": "Edited illustrative assumptions",
  "client-projection-v1-assumptions-return-basis": "Returns are net of investment and advisory fees, before tax.",
  "client-projection-v1-assumptions-lower-return": "Lower nominal return",
  "client-projection-v1-assumptions-base-return": "Base nominal return",
  "client-projection-v1-assumptions-higher-return": "Higher nominal return",
  "client-projection-v1-assumptions-inflation": "Nominal inflation",
  "client-projection-v1-assumptions-savings-growth": "Nominal savings growth",
  "client-projection-v1-assumptions-plan-through": "Plan-through age",
  "client-projection-v1-assumptions-percent-value": "{{value}}% nominal",
  "client-projection-v1-assumptions-age-value": "Age {{age}}",
  "client-projection-v1-rate-error": "Enter a rate from -99% through 100%.",
  "client-projection-v1-return-order-error": "Keep Lower at or below Base, and Base at or below Higher.",
  "client-projection-v1-plan-through-age-error": "Enter a whole age from {{minimum}} through {{maximum}}.",
  "client-projection-v1-methodology-heading": "How this is calculated",
  "client-projection-v1-methodology-show": "Review calculation details",
  "client-projection-v1-methodology-hide": "Hide calculation details",
  "client-projection-v1-methodology-today-dollars-label": "Today’s dollars",
  "client-projection-v1-methodology-today-dollars": "Nominal returns, savings growth, and future fixed amounts are converted using the inflation assumption.",
  "client-projection-v1-methodology-timing-label": "Annual timing",
  "client-projection-v1-methodology-timing": "The model keeps full precision and applies annual growth and cash flows at year end; displayed values are rounded.",
  "client-projection-v1-methodology-paths-label": "Comparison paths",
  "client-projection-v1-methodology-paths": "Lower, Base, and Higher are deterministic return assumptions, not probability estimates.",
  "client-projection-v1-methodology-assets-label": "Asset treatment",
  "client-projection-v1-methodology-assets": "Pre-tax and taxable assets are counted dollar for dollar; account-level taxes are not estimated.",
  "client-projection-v1-methodology-income-dates-label": "Income dates",
  "client-projection-v1-methodology-income-dates": "Income effective on a birthday starts in that whole-age interval; later dates start at the next whole age, without partial-year proration.",
  "client-projection-v1-methodology-exclusions-label": "Not modeled",
  "client-projection-v1-methodology-exclusions": "Sequence-of-returns variation, taxes, RMDs, account tax treatment, allocation changes, home equity, and estate planning are excluded.",
  "client-projection-v1-methodology-limitations-label": "Limitations",
  "client-projection-v1-methodology-limitations": "Results are hypothetical illustrations, not predictions or guarantees.",
  "client-projection-income-heading": "Guaranteed income",
  "client-projection-income-show": "Review income sources",
  "client-projection-income-hide": "Hide income sources",
  "client-projection-income-summary-empty": "No guaranteed income sources",
  "client-projection-income-summary": "{{included}} of {{total}} included",
  "client-projection-income-unreviewed-warning": "Sources need review",
  "client-projection-income-incomplete-summary": "{{count}} incomplete",
  "client-projection-income-empty": "No guaranteed income sources were found.",
  "client-projection-income-include": "Include {{name}}",
  "client-projection-income-status-included": "Included",
  "client-projection-income-status-excluded": "Excluded",
  "client-projection-income-status-unreviewed": "Review required",
  "client-projection-income-status-incomplete": "Incomplete · excluded",
  "client-projection-income-type-social-security": "Social Security",
  "client-projection-income-type-pension": "Pension",
  "client-projection-income-type-annuity": "Annuity",
  "client-projection-income-type-other": "Other",
  "client-projection-income-owner": "Owner",
  "client-projection-income-owner-missing": "Not provided",
  "client-projection-income-owner-household-member": "Household member",
  "client-projection-income-source": "Source",
  "client-projection-income-source-details-label": "{{name}} source details",
  "client-projection-income-observed-annual": "Observed annual amount",
  "client-projection-income-effective-date": "Effective date",
  "client-projection-income-value-missing": "Not provided",
  "client-projection-income-modeling-heading": "Modeling assumptions",
  "client-projection-income-annual-amount": "Modeled annual amount",
  "client-projection-income-amount-help": "Enter the amount to model.",
  "client-projection-income-amount-basis": "Amount basis",
  "client-projection-income-basis-current": "Current annual payment",
  "client-projection-income-basis-future": "Future start-year nominal amount",
  "client-projection-income-active-basis-help": "Active sources use the current annual payment.",
  "client-projection-income-inflation-treatment": "Annual amount treatment",
  "client-projection-income-inflation-linked": "Inflation-linked",
  "client-projection-income-fixed-nominal": "Fixed nominal",
  "client-projection-income-start-age": "Start age",
  "client-projection-income-start-age-help": "Derived from the source effective date.",
  "client-projection-income-end-age": "End age (exclusive)",
  "client-projection-income-end-age-help": "Leave blank for lifetime.",
  "client-projection-income-pre-retirement": "Before retirement",
  "client-projection-income-pre-retirement-spent": "Assumed spent",
  "client-projection-income-pre-retirement-assets": "Add to projected assets",
  "client-projection-income-confirm-current-amount": "Confirm {{amount}} annual payment",
  "client-projection-income-issue-active-confirmation": "Confirm the current annual payment below.",
  "client-projection-income-issue-amount": "Enter a smaller annual amount of $0 or more.",
  "client-projection-income-issue-start-after-plan": "This source starts after the current plan. Extend plan-through age or exclude this source.",
  "client-projection-income-issue-start": "Start age does not match the source data. Exclude this source or review its effective date.",
  "client-projection-income-issue-end": "End age must be after start age and within the plan.",
  "client-projection-income-issue-active-basis": "Active sources must use the current annual payment.",
  "client-projection-income-issue-annuity": "An annuity is included as both an account and income. Include it only once.",
  "client-projection-income-issue-incomplete": "Complete the source data before including it.",
  "client-projection-v1-milestones-heading": "Milestones",
  "client-projection-v1-milestones-context": "Add one-time cash flows that materially change the projection. Amounts are modeled in today’s dollars.",
  "client-projection-v1-milestones-add": "Add milestone",
  "client-projection-v1-milestones-empty": "No one-time milestones are included.",
  "client-projection-v1-milestones-age": "Age {{age}}",
  "client-projection-v1-milestones-edit-label": "Edit {{name}}",
  "client-projection-v1-milestone-add-title": "Add milestone",
  "client-projection-v1-milestone-edit-title": "Edit milestone",
  "client-projection-v1-milestone-close": "Close milestone editor",
  "client-projection-v1-milestone-name": "Milestone name",
  "client-projection-v1-milestone-type": "Milestone type",
  "client-projection-v1-milestone-type-placeholder": "Choose a type",
  "client-projection-v1-milestone-type-education": "Education",
  "client-projection-v1-milestone-type-home": "Home",
  "client-projection-v1-milestone-type-windfall": "Windfall",
  "client-projection-v1-milestone-type-travel": "Travel",
  "client-projection-v1-milestone-type-expense": "Expense",
  "client-projection-v1-milestone-type-other": "Other",
  "client-projection-v1-milestone-direction": "Cash-flow direction",
  "client-projection-v1-milestone-inflow": "Money received",
  "client-projection-v1-milestone-outflow": "Money spent",
  "client-projection-v1-milestone-amount": "Amount in today’s dollars",
  "client-projection-v1-milestone-event-age": "Age",
  "client-projection-v1-milestone-event-age-range": "Age {{minimum}}–{{maximum}}",
  "client-projection-v1-milestone-name-required": "Enter a milestone name.",
  "client-projection-v1-milestone-type-required": "Choose a milestone type.",
  "client-projection-v1-milestone-direction-required": "Choose whether money is received or spent.",
  "client-projection-v1-milestone-amount-error": "Enter a smaller amount greater than $0.",
  "client-projection-v1-milestone-age-error": "Enter a whole age from {{minimum}} through {{maximum}}.",
  "client-projection-v1-milestone-add-action": "Add milestone",
  "client-projection-v1-milestone-update-action": "Update milestone",
  "client-projection-v1-milestone-delete-action": "Delete",
  "client-projection-v1-milestone-delete-confirm-title": "Delete milestone?",
  "client-projection-v1-milestone-delete-confirm-body": "Remove {{name}} from this temporary scenario?",
  "client-projection-v1-milestone-delete-confirm-action": "Delete milestone",
  "client-projection-v1-milestone-delete-cancel-action": "Keep milestone",
  "client-projection-v1-milestone-delete-close-label": "Cancel milestone deletion",
  "client-projection-v1-review-inputs": "Review confirmed inputs",
  "client-projection-v1-planning-person": "Planning person",
  "client-projection-v1-retirement-age": "Retirement age",
  "client-projection-v1-included-accounts": "Included accounts",
  "client-projection-path-lower": "Lower · {{return}} nominal",
  "client-projection-path-base": "Base · {{return}} nominal",
  "client-projection-path-higher": "Higher · {{return}} nominal",
  "client-projection-chart-view": "Chart",
  "client-projection-table-view": "Table",
  "client-projection-view-toggle-label": "Projection view",
  "client-projection-independent-scales": "Independent scales",
  "client-projection-zero-reference": "Zero assets",
  "client-projection-shortfall-reference": "First unfunded cash flow",
  "client-projection-milestone-marker-label": "{{count}} milestones at age {{age}}: {{names}}",
  "client-projection-table-region-label": "Projection values",
  "client-projection-table-caption": "Projection by age and modeled cash flow",
  "client-projection-table-scroll-hint": "Scroll horizontally to view all columns.",
  "client-projection-table-age": "Age",
  "client-projection-table-year": "Year",
  "client-projection-annual-savings": "Annual savings",
  "client-projection-guaranteed-income": "Guaranteed income",
  "client-projection-milestone-net-cash-flow": "Milestone net cash flow",
  "client-projection-ending-assets": "Ending assets",
  "client-projection-annual-unfunded": "Annual unfunded cash flow",
  "client-projection-cumulative-unfunded": "Cumulative unfunded cash flow",
  "client-projection-retirement-reference": "Retirement age",
  "client-details-documents-heading": "Documents",
  "client-details-documents-client-uploads-heading": "Client Uploads",
  "client-details-documents-uploaded-heading": "Uploaded Documents",
  "client-details-upload-document": "Upload Document",
  "client-details-documents-search-placeholder": "Search document titles",
  "client-details-documents-search-empty": "No documents match this search.",
  "client-details-documents-empty": "No uploaded documents yet.",
  "client-details-document-delete-success": "“{{- fileName}}” was deleted.",
  "client-details-documents-loading": "Loading documents...",
  "client-details-documents-error": "Documents could not be loaded.",
  "client-details-documents-retry": "Retry",
  "client-details-documents-associations-error": "Some document details could not be verified. Try again to restore source information.",
  "client-details-documents-associations-retry": "Retry association check",
  "client-details-documents-unavailable": "Documents are not enabled.",
  "client-details-documents-source-client-upload": "Client Upload",
  "client-details-documents-source-general": "General",
  "client-details-documents-more-sources": "+{{count}} more",
  "client-details-documents-source-accounts": "Accounts",
  "client-details-documents-source-business": "Business",
  "client-details-documents-source-real-estate": "Real Estate",
  "client-details-documents-source-notes": "Notes",
  "client-details-documents-source-property": "Property",
  "client-details-documents-source-debts": "Debts",
  "household-elements-customization-link-label": "Customize Elements",
  "household-elements-customization-description": "Choose which Elements are visible for this household.",
  "household-elements-customization-disabled-message": "Customize Elements is not enabled for this firm yet.",
  "household-elements-customization-firm-setting": "Firm setting",
  "household-elements-customization-show": "Show",
  "household-elements-customization-hide": "Hide",
  "household-elements-customization-visible-by-firm": "Visible by firm setting",
  "household-elements-customization-hidden-by-firm": "Hidden by firm setting",
  "household-elements-customization-shown-by-household": "Shown for this household",
  "household-elements-customization-hidden-by-household": "Hidden for this household",
  "household-element-customization-save-success": "Household Element visibility updated.",
  "household-element-customization-save-error": "Unable to update household Element visibility.",

  "income-page-heading": "Income & Spending",
  "income-page-description": "Manage household income sources and spending estimates here.",
  "income-page-empty-description": "Add your household income sources to estimate the amount you expect to earn during the current year.",
  "income-page-segmented-control-income": "Income Sources",
  "income-page-segmented-control-spending": "Spending",
  "income-page-add-income-source-button": "Add Income Source",
  "income-page-total-income-row-title": "Total Household Income",

  "spending-page-description": "Make sure to include all debt payments (currently {{- debtPaymentsDisplay}} {{- frequencySuffix}}) in this estimate.  We'll back out the Debt Payments from Burn Rate so they don't get double counted with Debt Rate too.",
  "spending-page-form-spending-amount-input-label": "Estimated Spending",

  "report-preview-page-action-button": "Download Report",
  "report-preview-page-report-name": "{{- givenName}} {{- familyName}}'s {{reportTypeDisplay}} ({{dateDisplay}})",
  "report-preview-error-page-modal-title": "Hmmmm...",
  "report-preview-error-page-modal-body": "Looks like we’re having trouble loading that report right now. Try again later. If this is happening to you frequently, contact us to help get to the bottom of this error.",
  "report-preview-error-page-modal-primary-action": "Contact Us",

  "download-element-report": "Download {{element}} Report",
  "download-report": "Download Report",
  "add-to-client-group": "Add to Group...",
  "remove-all-custom-groups": "Remove from All",
  "client-groups-move-to-group": "{{- name}} moved to \"{{- group}}\"",
  "change-client-notifications": "Communication Preferences",
  "change-client-notifications-description": "Select which team members receive email notifications when this client takes action (e.g., completes onboarding, sends a message).",
  "change-client-notifications-description-opt-out": "Select which team members receive email notifications. Leave all selected to notify everyone.",
  "change-client-notifications-description-opt-in": "Select which team members receive email notifications. Only selected advisors will be notified.",
  "client-notifications-updated": "Communication preferences updated.",
  "client-notifications-update-error": "Failed to update communication preferences. Please try again.",
  "client-notifications-select-all": "Select all",
  "client-groups-removed-from-group": "{{- name}} removed from \"{{- group}}\"",

  "ai-assessment": {
    "invite-link": {
      "toggle-disclaimer": {
        "on": "Clients who onboard with this link will automatically be directed to an AI generated assessment at the end of onboarding.",
        "off": "Clients who onboard with this link will be directed to their Elements Scorecard or their custom assessment, if present, after onboarding."
      }
    },
    "client-options": {
      "toggle-disclaimer": {
        "on": "This client will be able to access and regenerate an AI assessment on their own",
        "off": "This client can only access assessments that have been manually edited and published by their advisor"
      }
    }
  }
}
